// extracted by mini-css-extract-plugin
module.exports = {"ButtonBase":"ButtonSearch_ButtonBase__1VgIM","ButtonPrimary":"ButtonSearch_ButtonPrimary__2SwZZ"};